import React from 'react';
export const AddElements = () => {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    height: "12",
    viewBox: "0 0 12 12",
    width: "12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.63462H5.36538V11V11.25H5.61538H6.38462H6.63462V11V6.63462H11H11.25V6.38462V5.61538V5.36538H11H6.63462V1V0.75H6.38462H5.61538H5.36538V1V5.36538H1H0.75V5.61538V6.38462V6.63462H1Z",
    fill: "#131720",
    stroke: "black",
    "stroke-width": "0.5"
  }));
};
//# sourceMappingURL=add-elements.js.map